import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c977d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "no-data-tip" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "video-content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src"]

import { Uploader } from 'vant'
import { getCompressImageFiles } from '@/compositions/useUpload'
import { Ref, ref, withDefaults, watch, nextTick } from 'vue'
import FileSvg from '@/assets/file.svg'
import BoFangSvg from '@/assets/bofang.svg'
import { Dialog, Overlay, ActionSheet } from 'vant'
import type { CommonUploaderFileListItem, GetCrmQiniuTokenResult } from '@/types/public'
import { getRepairQiniuToken, qiniuKeyConvert } from '@/apis/public'
import { showToastFail } from '@/utils/tools'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import UploadAdd from '@/assets/upload-add.svg'
import type { ActionSheetAction } from 'vant'
import { isAgriApp, isApp } from '@/utils/app'
import { useUserPermissionVerify } from '@/compositions/useUserAuthPermission'

export type InitData = {
  addFiles: (files: File[]) => void
  setFileList: (list: CommonUploaderFileListItem[]) => void
}

export function judgeMp4(url: string) {
  console.log('judgeMp4', url)
  if (!url) {
    return false
  }
  let pos = url.lastIndexOf('/')
  let str = url.substr(pos + 1)
  let name = str.split('.')
  if (name[1]) {
    console.log(
      'ddd',
      name[1],
      name[1].startsWith('mp4') ||
        name[1].startsWith('MP4') ||
        name[1].startsWith('MOV') ||
        name[1].startsWith('mov')
    )
    return (
      name[1].startsWith('mp4') ||
      name[1].startsWith('MP4') ||
      name[1].startsWith('MOV') ||
      name[1].startsWith('mov')
    )
  }
  return false
}

export default /*#__PURE__*/_defineComponent({
  __name: 'newUploadFIle',
  props: {
    defaultList: { default: () => [] },
    maxCount: { default: 'Infinity' },
    capture: null,
    acceptValue: { default: '*' },
    showUpload: { type: Boolean, default: true },
    deletable: { type: Boolean, default: true },
    cameraAuthKey: null,
    needAuth: { type: Boolean, default: true },
    className: { default: '' }
  },
  emits: ['change', 'init'],
  setup(__props: any, { emit: emits }) {

const props = __props as { defaultList: CommonUploaderFileListItem[], maxCount: string | number, capture?: string, acceptValue: string, showUpload: boolean, deletable: boolean, cameraAuthKey?: string, needAuth: boolean, className: string };


const { checkAuthorizationHandle, hasAuthorized } = useUserPermissionVerify(props.cameraAuthKey)
const overlayRef = ref(null)
const overlayShow = ref(false)
const currentVideoUrl = ref('')
let QiniuTokenInfo: null | GetCrmQiniuTokenResult = null

const photoshow = ref(false)
// 农服无系统文件 自驾仪 隐藏系统文件
let photoActions = [{ name: '视频拍摄' }, { name: '系统文件' }]

if (isApp && !isAgriApp) {
  photoActions = [{ name: '视频拍摄' }]
}

function overlayCloseHandle() {
  overlayShow.value = false
  if (overlayRef.value) {
    document.body.removeChild(overlayRef.value.$el)
  }
}

async function getCrmQiniuTokenHandle() {
  if (!QiniuTokenInfo) {
    try {
      const data = await getRepairQiniuToken()
      console.log('dd', data)
      QiniuTokenInfo = {
        key_prefix: 'sanzhumu',
        url: 'https://upload.qiniup.com',
        use_cdn_domain: false,
        token: data.uptoken,
      }
    } catch (error) {
      showToastFail('获取上传凭证失败')
      return Promise.reject(error)
    }
  }
  return QiniuTokenInfo
}

async function uploadCrmQiniuHandle(
  file: File,
  tokenInfo: GetCrmQiniuTokenResult
): Promise<{
  key: string
}> {
  function rename(filename: string) {
    const uuid = uuidv4()
    const nameArr = filename ? filename.split('.') : []
    const suffix = nameArr[1]
    return `${uuid}.${suffix || ''}`
  }
  const { url, key_prefix, token } = tokenInfo
  const key = `${key_prefix}/${rename(file.name)}`
  const data = {
    file,
    token,
    url: url.replace(/^http:\/\//i, 'https://'),
    key,
  }
  const param = new FormData()
  const config = {
    headers: { 'Content-Type': 'multipart/form-data' },
  }
  param.append('file', data.file)
  param.append('token', data.token)
  param.append('key', data.key)
  try {
    const result = await axios.post(data.url, param, config)
    return result.data
  } catch (error) {
    return Promise.reject(error)
  }
}

async function vantCrmUploadHandle(fileList: CommonUploaderFileListItem[]) {
  fileList.forEach((item) => {
    // 全部设置为上传中
    item.status = 'uploading'
    item.message = '上传中...'
  })
  let tokenInfo: GetCrmQiniuTokenResult
  try {
    tokenInfo = await getCrmQiniuTokenHandle()
  } catch (error) {
    fileList.forEach((item) => {
      // 全部设置为上传失败
      item.status = 'failed'
      item.message = '上传失败'
    })
    console.log('getCrmQiniuTokenHandle', error)
    return
  }
  const compressorList: File[] = await getCompressImageFiles(fileList.map((item) => item.file))
  async function uploadWrap(fileItem: CommonUploaderFileListItem, file: File) {
    try {
      const result = await uploadCrmQiniuHandle(file, tokenInfo)
      // 转换后台coverkey
      console.dir(file)
      const formData: FormData = new FormData()
      formData.append('keys[]', result.key)
      let data = await qiniuKeyConvert(formData)
      let key = data[result.key]
      fileItem.status = 'done'
      fileItem.url = URL.createObjectURL(file)
      fileItem.isVideo = judgeMp4(file.name)
      fileItem.response = {
        guid: key,
        url: URL.createObjectURL(file),
        fileName: file.name,
      }
    } catch (error) {
      fileItem.status = 'failed'
      return Promise.reject(error)
    }
  }
  async function judgeVideoFileLimit(file: File) {
    return new Promise((resolve, reject) => {
      // 创建一个video元素
      try {
        // const video = document.createElement('video');
        // 设置视频的src属性
        let url = URL.createObjectURL(file)
        const audio = new Audio(url)
        audio.muted = true
        audio.play().then(() => audio.pause())
        // 监听视频的loadedmetadata事件，该事件在视频的元数据加载完成后触发
        audio.addEventListener('loadedmetadata', () => {
          // 获取视频的时长（以秒为单位）
          const duration = audio.duration
          console.log('视频时长:', duration, '秒')
          if (duration > 60) {
            Dialog.alert({
              title: '提示',
              message: '视频时长不能超过60秒',
              confirmButtonColor: 'rgba(0, 195, 120, 1)',
              confirmButtonText: '知道了',
            })
            reject(false)
            return
          }
          resolve(true)
        })

        // 加载视频
        // video.load();
      } catch (e) {
        console.log('judgeVideoFileLimit', e)
        reject(false)
      }
    })
  }
  async function judgeOtherFileLimit(file: File) {
    return new Promise((resolve, reject) => {
      try {
        if (file.size / (1024 * 1024) > 20) {
          Dialog.alert({
            title: '提示',
            message: '非视频文件文件大小不能超过20MB',
            confirmButtonColor: 'rgba(0, 195, 120, 1)',
            confirmButtonText: '知道了',
          })
          reject(false)
        } else {
          resolve(true)
        }
      } catch (e) {
        console.log('judgeOtherFileLimit', e)
        reject(false)
      }
    })
  }

  async function judgeFileLimit(file: File) {
    try {
      if (file.type.startsWith('video/')) {
        return await judgeVideoFileLimit(file)
      } else {
        return await judgeOtherFileLimit(file)
      }
    } catch (e) {
      console.log('judgeFileLimit', e)
      return Promise.reject(e)
    }
  }
  console.log('compressorList', compressorList)
  const promiseList = compressorList.map(async (file, index) => {
    try {
      await judgeFileLimit(file)
      await uploadWrap(fileList[index], file)
    } catch (e) {
      fileList[index].status = 'failed'
      fileList[index].message = '上传失败'
      console.log('judgeFileLimit----')
    }
  })

  // const promiseList = compressorList.map((file, index) => uploadWrap(fileList[index], file))
  try {
    await Promise.all(promiseList)
  } catch (error) {
    console.log('Promise.all(promiseList)', error)
    return Promise.reject(error)
  }
}


const fileList: Ref<CommonUploaderFileListItem[]> = ref(props.defaultList)
function addFiles(files: File[]) {
  // 手动添加file文件
  fileList.value = fileList.value.concat(
    files.map((file) => ({
      status: '',
      file,
    }))
  )
  afterReadHandle()
}
function changeHandle() {
  emits('change', fileList.value)
}

function handleFileChange(event: Event) {
  const target = event.target as HTMLInputElement
  const files = target.files
  if (files && files.length > 0) {
    const file = files[0]
    console.log('Selected file:', file)

    // 在这里可以进行文件上传或其他处理
    addFiles(Array.from(files))
    afterReadHandle()
  }
}

emits('init', {
  addFiles,
  setFileList,
})
async function afterReadHandle() {
  try {
    const list = fileList.value.filter((item) => item.status === '')
    await vantCrmUploadHandle(list)
    console.log('dddd')
    changeHandle()
  } catch (e) {
    console.log('afterReadHandle', e)
  }
}

function deleteHandle() {
  changeHandle()
}

function judgeImg(url: string) {
  if (!url) {
    return false
  }
  let pos = url.lastIndexOf('/')
  let str = url.substr(pos + 1)
  let name = str.split('.')
  if (name[1]) {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
    return imageExtensions.includes(name[1].toLowerCase())
  }
  return false
}

function setFileList(list: CommonUploaderFileListItem[]) {
  fileList.value = list
}

watch(
  () => fileList.value,
  () => {
    nextTick(() => {
      let fileBox
      if (props.className) {
        // 先找到className对应的父元素，再在其下查找van-uploader__file类
        const parentElements = document.getElementsByClassName(props.className)
        if (parentElements.length > 0) {
          fileBox = parentElements[0].getElementsByClassName('van-uploader__file')
        } else {
          fileBox = []
        }
      } else {
        // 如果没有指定className，则在整个文档中查找
        fileBox = document.getElementsByClassName('van-uploader__file')
      }
      console.log('fileBox', fileBox)
      const showNoSupport = () => {
        Dialog.alert({
          title: '提示',
          message: '暂不支持手机预览文件格式',
          confirmButtonColor: 'rgba(0, 195, 120, 1)',
          confirmButtonText: '知道了',
        })
      }
      Array.from(fileBox).map((fileBoxItem, index) => {
        console.log(
          'fileBox',
          fileBoxItem,
          fileList.value[index],
          fileList.value[index].url,
          judgeMp4(fileList.value[index].url)
        )
        if (!fileList.value[index].isVideo) {
          if (!judgeImg(fileList.value[index].url)) {
            if (fileList.value[index].url) {
              fileBoxItem.addEventListener('click', showNoSupport)
            }
            let fileName = fileBoxItem.getElementsByClassName('van-uploader__file-name')[0]
            // 更具文件类型判断
            fileName.innerHTML = '文件'
            fileBoxItem.firstElementChild.outerHTML = `<img width="37" height="47" src='${FileSvg}' style="margin-top: 10px;margin-bottom: -6px;"></img>`
          }
        } else {
          // MP4
          fileBoxItem.removeEventListener('click', showNoSupport)
          fileBoxItem.addEventListener('click', async () => {
            // 打开视频预览
            console.log('打开视频预览')
            currentVideoUrl.value = fileList.value[index].url
            overlayShow.value = true
            await nextTick()
            console.log('overlayRef', overlayRef.value)
            if (overlayRef.value) {
              document.body.appendChild(overlayRef.value.$el)
            }
            nextTick(() => {
              let video: HTMLMediaElement = document.getElementById(
                'video-play'
              ) as HTMLMediaElement
              console.log('video', video)
              video.play()
            })
          })
          let fileName = fileBoxItem.getElementsByClassName('van-uploader__file-name')[0]
          // 更具文件类型判断
          // fileName.innerHTML = '文件'
          fileBoxItem.firstElementChild.outerHTML = `<div class="video-wrap">
            <video x5-playsinline="" muted="" webkit-playsinline="" playsinline="" loop="true" controlslist="nodownload" class="video autoplay-video superx8-content-item-video" src="${fileList.value[index].url}">
            </video>
            <img width="20" height="20" class="play-btn" src="${BoFangSvg}" />
          </div>`
        }
      })
    })
  },
  {
    immediate: true,
    deep: true,
  }
)

function selectFileHandle() {
  console.log('selectFileHandle')
  if (isAgriApp) {
    onFileSelect({}, 0)
    return
  }
  photoshow.value = true
}

function onCancel() {
  console.log('onCancel')
}

let videoInputRef = ref<HTMLInputElement | null>(null)
let fileInputRef = ref<HTMLInputElement | null>(null)

async function onFileSelect(action: ActionSheetAction, index: number) {
  // console.log('onFileSelect', action, index)
  // console.log('videoInputRef.value', videoInputRef.value, fileInputRef.value)
  if (index === 0) {
    // 视频拍摄
    if (videoInputRef.value?.value) {
      videoInputRef.value.value = ''
    }
    if (props.needAuth && props.cameraAuthKey && !hasAuthorized.value) {
      try {
        const userAgree = await checkAuthorizationHandle(props.cameraAuthKey)
        if (!userAgree) {
          console.warn('用户拒绝授权')
          return
        }
      } catch (error) {
        console.log('error', error)
        return
      }
    }
    videoInputRef.value?.click()
  } else if (index === 1) {
    if (isAgriApp) {
      // 农服版本提示不支持
      Dialog.alert({
        title: '提示',
        message: '农服当前版本不支持上传系统文件',
        confirmButtonColor: 'rgba(0, 195, 120, 1)',
        confirmButtonText: '知道了',
      })
      return
    }
    // 系统文件
    if (fileInputRef.value?.value) {
      fileInputRef.value.value = ''
    }
    fileInputRef.value?.click()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["upload-item", __props.className])
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(!__props.deletable && fileList.value.length === 0 ? '暂无数据' : ''), 1),
      _createVNode(_unref(Uploader), {
        class: "custom-wrap",
        afterRead: afterReadHandle,
        modelValue: fileList.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fileList).value = $event)),
        multiple: "",
        "upload-icon": "plus",
        "max-count": __props.maxCount,
        onDelete: deleteHandle,
        accept: __props.acceptValue,
        capture: __props.capture,
        "preview-full-image": false,
        "show-upload": __props.showUpload,
        deletable: __props.deletable
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "upload-btn",
            onClick: selectFileHandle
          }, [
            _createElementVNode("img", {
              class: "upload-btn-icon",
              src: _unref(UploadAdd)
            }, null, 8, _hoisted_2)
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "max-count", "accept", "capture", "show-upload", "deletable"])
    ], 2),
    _createElementVNode("img", {
      src: _unref(FileSvg),
      style: {"display":"none"}
    }, null, 8, _hoisted_3),
    _createElementVNode("img", {
      src: _unref(BoFangSvg),
      style: {"display":"none"}
    }, null, 8, _hoisted_4),
    _createVNode(_unref(Overlay), {
      show: overlayShow.value,
      onClick: overlayCloseHandle,
      class: "van-overlay",
      ref_key: "overlayRef",
      ref: overlayRef
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "close-item",
            onClick: _withModifiers(overlayCloseHandle, ["stop"])
          }, null, 8, _hoisted_6),
          _createElementVNode("video", {
            "x5-playsinline": "",
            muted: "",
            "webkit-playsinline": "",
            playsinline: "",
            loop: "true",
            controlslist: "nodownload",
            controls: "",
            id: "video-play",
            src: currentVideoUrl.value
          }, null, 8, _hoisted_7)
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(ActionSheet), {
      show: photoshow.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((photoshow).value = $event)),
      actions: _unref(photoActions),
      onSelect: onFileSelect,
      "cancel-text": "取消",
      "close-on-click-action": "",
      teleport: "body",
      onCancel: onCancel
    }, null, 8, ["show", "actions"]),
    _createElementVNode("input", {
      type: "file",
      ref_key: "videoInputRef",
      ref: videoInputRef,
      style: { display: 'none' },
      accept: "video/*",
      capture: "camcorder",
      onChange: handleFileChange
    }, null, 544),
    _createElementVNode("input", {
      type: "file",
      ref_key: "fileInputRef",
      ref: fileInputRef,
      style: { display: 'none' },
      accept: ".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx",
      onChange: handleFileChange
    }, null, 544)
  ], 64))
}
}

})